import React from "react";
import { buildClass } from "@utils/tag";
import { Text } from "@utils/helper";

const Tabs = ({ tabs, value, handleChangeTab }) => {
  return (
    <div className="flex flex-col md:flex-row gap-2 md:gap-[22px]">
      {tabs?.map((tab, i) => {
        const isActive = value === tab.value;
        return (
          <div
            key={i}
            onClick={() => handleChangeTab(tab.value)}
            className={buildClass(
              "flex justify-start items-center p-2",
              "md:py-5 md:px-8 cursor-pointer h-10 md:h-full",
              "rounded-[20px]"
            )}
            style={{
              zIndex: 5 - i,
              boxShadow: "0px 0px 35px 0px #486AB514",
              background: isActive ? "#FFFFFF" : "#F8FBFF",
            }}
          >
            <Text
              xs={{
                color: "#333333",
                opacity: isActive ? 1 : 0.6,
              }}
              fontType="Expo_sim"
              weight={500}
              className={`relative !text-[14px] md:!text-[20px]`}
            >
              {tab.label}
            </Text>
          </div>
        );
      })}
    </div>
  );
};

export default Tabs;
